import { Theme } from '@material-ui/core';

import { NonHoverBorder } from 'src/theme/colors';

export default {
  colorPrimary: {
    '&$checked': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    color: NonHoverBorder,
  },
};

export const overrideRadio = (theme: Theme) => {
  if (theme.overrides && theme.overrides.MuiRadio) {
    theme.overrides.MuiRadio = {
      colorPrimary: {
        ...theme.overrides.MuiRadio.colorPrimary,
        '&:hover': {
          backgroundColor: 'transparent',
          color: theme.palette.primary.main,
        },
      },
    };
  }
};
